<template>
  <video
    :poster="posterUrl"
    class="media-player"
    preload="metadata"
    controls
    width="100%"
    height="100%"
  >
    <source :src="blok.asset?.filename" />
    <track
      v-for="webvtt in blok.subtitles"
      :key="webvtt._uid"
      :label="webvtt.label"
      :srclang="webvtt.language"
      :src="fileWithCORSHeaders(webvtt.filename)"
      kind="captions"
    />
  </video>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
});

const posterUrl = computed(() => {
  const transformed = buildStoryblokImageUrl(props.blok.poster?.filename);
  if (!transformed) return undefined;

  return fileWithCORSHeaders(transformed);
});

const fileWithCORSHeaders = (filename) => {
  return filename.replace("//a.storyblok.com", "//a2.storyblok.com");
};
</script>

<style lang="scss" scoped>
.media-player {
  border-radius: $radius-l;
  width: 100%;
}
</style>
